import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllFeatures } from "../actions/machine-action-types";
import { isEmpty } from "lodash";

const useGetAllFeatures = () => {
  const dispatch = useDispatch();

  const allFeatures = useSelector((state) => state?.machine?.allFeatures);

  const groupFeatureList = useMemo(() => {
    let result = [];
    if (!isEmpty(allFeatures)) {
      for (let item of allFeatures) {
        const addedItem =
          result.find((obj) => {
            return obj.groupId === item.groupId;
          }) ?? {};
        if (isEmpty(addedItem)) {
          const grpObj = {
            groupId: item.groupId,
            grpFeatureId: item.grpFeatureId,
            groupName: item.groupName,
            features: [
              {
                featureId: item.featureId,
                featureName: item.featureName,
              },
            ],
          };
          result.push(grpObj);
        } else {
          // Check Features
          const features = addedItem.features;
          const addedFeatures = features.find((obj) => {
            return obj.featureId === item.featureId;
          });
          if (isEmpty(addedFeatures)) {
            const updatedFeatures = [
              ...features,
              {
                featureId: item.featureId,
                featureName: item.featureName,
              },
            ];
            result = result.map((rItem) => {
              if (rItem.groupId === addedItem.groupId) {
                return {
                  ...rItem,
                  features: updatedFeatures,
                };
              }
              return rItem;
            });
          }
        }
      }
      return result;
    }
    return result;
  }, [allFeatures]);

  // Fetch All Feature List
  const fetchAllFeatureList = () => {
    dispatch(getAllFeatures());
  };

  return { fetchAllFeatureList, groupFeatureList };
};

export default useGetAllFeatures;
